import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../services/language.service';
import { ChatContext } from '../models/chat.models';

/**
 * ChatContextService — Builds a privacy-safe snapshot of the current screen.
 *
 * Used to enrich the user's question with contextual information
 * so the RAG backend can provide more relevant answers.
 *
 * IMPORTANT: Never include PII (emails, internal IDs, tokens, etc.).
 */
@Injectable({ providedIn: 'root' })
export class ChatContextService {

  constructor(
    private router: Router,
    private languageService: LanguageService
  ) {}

  getContextSnapshot(): ChatContext {
    const route = this.router.url;
    return {
      route,
      screenName: this.resolveScreenName(route),
      locale: this.languageService.getCurrentLanguage(),
      timestamp: new Date().toISOString()
    };
  }

  /**
   * Derive a human-readable screen name from the current route.
   */
  private resolveScreenName(route: string): string {
    const mapping: Record<string, string> = {
      '/login':              'Inicio de sesión',
      '/welcome':            'Bienvenida',
      '/create-account':     'Registro de cuenta',
      '/reset-password':     'Recuperar contraseña',
      '/reports':            'Reportes',
      '/account-settings':   'Configuración de cuenta',
      '/customer-plans':     'Planes del cliente',
      '/customer-cards':     'Tarjetas del cliente',
      '/customer-invoices':  'Facturas del cliente',
      '/add-client':         'Agregar cliente',
      '/faqs':               'Preguntas frecuentes',
      '/select-portal':      'Seleccionar portal',
      '/onboarding-users':   'Usuarios de onboarding'
    };

    // Try exact match first, then prefix match
    const exactMatch = mapping[route];
    if (exactMatch) return exactMatch;

    const prefixMatch = Object.entries(mapping).find(([key]) => route.startsWith(key));
    return prefixMatch ? prefixMatch[1] : 'General';
  }
}
